import type { TOC } from '@ember/component/template-only';

import DataManagerAvailableComponent from 'webapp/components/data-manager/available';

const DatamanagerAvailableRouteTemplate: TOC<object> = <template>
	<DataManagerAvailableComponent />
</template>;

export default DatamanagerAvailableRouteTemplate;
